<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Administration"
                   :links="[{title:'Home', url:'/'},{title:'Administration'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="1"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Administration</div>
          <p class="text-gray-600 text-justify font-normal">The admin department is responsible for providing various
            services and support to stakeholders. To maintain the smooth functioning and appropriate coordination among
            the various departments admin plays the role as backbone of the institute. Admin is an important constituent
            of the governance in the institute that comprises of Human Resource Management, Finance and Accounts,
            Students Support and Central Store.</p>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/administration/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Administration",
  components: {
    KeyRecruiters,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      div: null,
      missions: ['Mission', 'Mission', 'Mission', 'Mission', 'Mission']
    }
  }
}
</script>
<style lang="scss" scoped/>
